import AxiosConfig from '@/config/axios-config'

export const AcessoSSOAPI = {
  tokenSSO () {
    return AxiosConfig.secureJalekoAPI().get('sso/token').then(response => response.data)
  },

  tokenWLSSO (empresaId) {
    return AxiosConfig.secureJalekoAPI().get('ssoWL/token', { params: { empresa_id: empresaId } }).then(response => response.data)
  }
}

export default AcessoSSOAPI
